import { Box, Card, Stack, Button, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { BRAND_COLOR } from 'src/theme/core';

export const StartWithCenterUpFinancialManage = ({
  setOpenDemoForm,
}: {
  setOpenDemoForm: (value: boolean) => void;
}) => {
  const lgDown = useResponsive('down', 'lg');
  const mdDown = useResponsive('down', 'md');
  const smDown = useResponsive('down', 'sm');
  const theme = useTheme();
  return (
    <Card
      sx={{
        my: 8,
        justifySelf: 'center',
        maxWidth: 1200,
        mx: lgDown ? 0 : 4,
        background: theme.palette.common.black,
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 0,
      }}
    >
      <Stack direction={mdDown ? 'column' : 'row'} justifyContent="space-between">
        <Stack alignItems="start" spacing={3} p={mdDown ? 2 : 6} flex={0.5} zIndex={2}>
          <Box component="img" src="/assets/sub-pages/logo-ant.svg" alt="logo" />
          <Stack>
            <Typography variant="h2" color="primary.contrastText">
              Bắt đầu ngay với CenterUp
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6" color="primary.contrastText" fontWeight="light">
              Không còn phải tính tay từng khoản thu – chi.
            </Typography>
            <Typography variant="h6" color="primary.contrastText" fontWeight="light">
              Không còn đối chiếu thủ công từng dòng học phí.
            </Typography>
          </Stack>
          <Typography variant="h6" color="primary.contrastText" fontWeight="bold">
            “Báo cáo rõ ràng – Dữ liệu tự động”
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Button
              onClick={() => setOpenDemoForm(true)}
              size="large"
              sx={{
                background: BRAND_COLOR,
                color: 'white',
                '&:hover': {
                  background: BRAND_COLOR,
                  opacity: 0.9,
                },
                minWidth: 124,
              }}
            >
              Đăng ký Demo
            </Button>
            <Typography
              fontSize={smDown ? 12 : 18}
              color="primary.contrastText"
              sx={{ maxWidth: smDown ? 180 : 280 }}
            >
              Để trải nghiệm quản lý tài chính hiệu quả hơn với CenterUp
            </Typography>
          </Stack>
        </Stack>
        <Stack flex={0.5} position="relative" zIndex={1}>
          <Stack justifyContent="center" alignItems="center" height="100%" zIndex={1}>
            <Box component="img" alt="class-report" src="/assets/sub-pages/ai.png" />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
